import React, { useState, useEffect, useCallback, useLayoutEffect } from 'react'
import PropTypes from 'prop-types'
import { CarouselNavigator, Image, CountDown } from 'components'
import Swiper from 'react-id-swiper'
import ContentLoader from 'react-content-loader'
import isPreRendering from 'utils/isPreRendering'
import {
  timerFirstCampaign,
  timerSecondCampaign,
  activeCountDownToFirstCampaign,
  activeCountDownToSecondCampaign,
  campaignConfigurations,
} from 'utils/checkCampaign'
import styles from './BannerCarousel.module.scss'

const BannerCarousel = ({ imageList, autoPlay }) => {
  const [bannerVisible, setBannerVisible] = React.useState(false)
  const [swiper, updateSwiper] = useState(null)
  const [selectedBanner, setSelectedBanner] = useState(0)
  const [displayCountdownFirst, setDisplayCountdownFirst] = useState(false)
  const [displayCountdownSecond, setDisplayCountdownSecond] = useState(false)

  useLayoutEffect(() => {
    if (!isPreRendering()) {
      setBannerVisible(true)
    }
    setTimeout(() => {
      setDisplayCountdownFirst(activeCountDownToFirstCampaign)
      setDisplayCountdownSecond(activeCountDownToSecondCampaign)
    }, 1500)
  }, [])

  const updateIndex = useCallback(() => {
    setSelectedBanner(swiper.realIndex)
  }, [swiper])

  useEffect(() => {
    if (swiper !== null) {
      swiper.on('slideChange', updateIndex)
    }

    return async () => {
      if (swiper !== null) {
        swiper.off('slideChange', updateIndex)
      }
    }
  }, [swiper, updateIndex, selectedBanner])

  const params = {
    wrapperClass: styles.swiper,
    slideClass: styles.slide,
    slidesPerView: 1,
    autoplay: {
      delay: 25000,
      disableOnInteraction: false,
      enabled: autoPlay,
    },
    getSwiper: updateSwiper,
  }

  const placeholder = (
    <ContentLoader height={150} className={styles.loader}>
      <rect x="0" y={0} rx="3" ry="3" width="100%" height={150} />
    </ContentLoader>
  )

  const filteredImageList = imageList.filter(
    ({ campaign }) => !campaign || process.env.REACT_APP_CAMPAIGN
  )

  if (!bannerVisible) return placeholder
  if (!imageList.length) return null

  return (
    <section className={styles.carousel}>
      <Swiper {...params}>
        {imageList.map(
          (
            { link, sourceMobile, sourceNormal, sourceLarge, alt, name },
            index
          ) => (
            <span key={index.toString()}>
              <Image
                key={index.toString()}
                className={styles.slide}
                link={link}
                alt={`Link para a pagina ${alt}`}
                sourceMobile={sourceMobile}
                source={sourceNormal}
                sourceLarge={sourceLarge}
                sourceXLarge={sourceLarge}
              />
              {displayCountdownFirst &&
                name &&
                campaignConfigurations(name).countDown && (
                  <span className={styles.countDown}>
                    <CountDown endDate={timerFirstCampaign()} />
                  </span>
                )}
              {displayCountdownSecond &&
                name &&
                campaignConfigurations(name).countDown && (
                  <span className={styles.countDown}>
                    <CountDown endDate={timerSecondCampaign()} />
                  </span>
                )}
            </span>
          )
        )}
      </Swiper>

      <div className={styles.navigator}>
        <CarouselNavigator
          size={filteredImageList.length}
          selected={selectedBanner}
          handleClick={key => swiper.slideTo(key, 0.2)}
        />
      </div>
    </section>
  )
}

BannerCarousel.propTypes = {
  imageList: PropTypes.arrayOf(
    PropTypes.shape({
      mobileSrc: PropTypes.string,
      normalSrc: PropTypes.string,
      largeSrc: PropTypes.string,
      link: PropTypes.string,
      alt: PropTypes.string,
    })
  ).isRequired,
  autoPlay: PropTypes.bool,
}

BannerCarousel.defaultProps = {
  autoPlay: false,
}
export default React.memo(BannerCarousel)
